































































































































import { Vue, Component, Mixins, Prop } from "vue-property-decorator";

import MyList from "@/mixins/list";

import AreaPicker from "@/components/areapicker.vue";

import { isAI, isCooperate, isTelBooking } from "@/libs/utils";

@Component({
  components: {
    AreaPicker
  }
})
export default class extends Mixins(MyList) {
  @Prop() stadium!: any;

  isAI: (...args: any[]) => any = isAI;

  isCooperate: (...args: any[]) => any = isCooperate;

  isTelBooking: (...args: any[]) => any = isTelBooking;

  dispatchType = "stadium/similar";

  columns: any[] = [
    { title: "编号", dataIndex: "id" },
    { title: "城市", dataIndex: "city_name" },
    { title: "场馆名称", dataIndex: "name" },
    { title: "馆长", dataIndex: "manager_name" },
    { title: "订场电话", dataIndex: "phone" },
    { title: "订场平台签约状态", scopedSlots: { customRender: "orderagree" } },
    { title: "智能场馆签约状态", scopedSlots: { customRender: "aiagree" } },
    { title: "入驻时间", dataIndex: "created_time" },
    { title: "上线状态", scopedSlots: { customRender: "online_status" } },
    { title: "场地片数", dataIndex: "ground_count" },
    {
      title: "场馆状态",
      width: 100,
      scopedSlots: { customRender: "stadium_status" }
    }
  ];

  async setStadiumStatus(val: any, id: number) {
    this.$confirm({
      title: "确认信息",
      content: `您确定要${val === false ? "下线" : "上线"}该场馆吗？`,
      onOk: async () => {
        if (!this.checkPermission("admin-stadiums-edit")) {
          this.$message.warning("没有权限");
          return;
        }
        const res = await this.$store.dispatch("stadium/stadiumstatus", {
          id,
          val
        });
        // console.log(res)
        if (res && res.Message && res.Message === "success") {
          this.$message.success("操作成功");
          this.loadData({}, false);
        } else {
          this.$message.error("操作失败");
        }
      }
    });
  }

  mounted() {
    this.loadData(
      {
        province_id: this.stadium.province_id,
        city_id: this.stadium.city_id,
        name: this.stadium.name,
        phone: this.stadium.phone,
        stadium_id: this.stadium.id
      },
      false
    );
  }
}
